import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flatMapByProperty',
})
export class FlatMapByPropertyPipe implements PipeTransform {
  transform(value: any, property: string): any {
    if (!value || !property) {
      return null;
    }
    return value.flatMap((x) => x[property]);
  }
}
